import { render, staticRenderFns } from "./ReDocWrapper.vue?vue&type=template&id=02b3e8fc"
import script from "./ReDocWrapper.vue?vue&type=script&lang=js"
export * from "./ReDocWrapper.vue?vue&type=script&lang=js"
import style0 from "./ReDocWrapper.vue?vue&type=style&index=0&id=02b3e8fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports